import { c as _c } from "react/compiler-runtime";
import { nebulyPalette } from '@/utils/colors';
import { cn } from '@/utils/shad';
const CircularPercentage = t0 => {
  const $ = _c(30);
  const {
    percentage,
    radius: t1,
    stroke: t2,
    className,
    displayAsNumber: t3,
    number,
    strokeColor,
    color: t4,
    colorHex,
    hideLabel: t5
  } = t0;
  const radius = t1 === undefined ? 10 : t1;
  const stroke = t2 === undefined ? 2 : t2;
  const displayAsNumber = t3 === undefined ? false : t3;
  const color = t4 === undefined ? "violet2" : t4;
  const hideLabel = t5 === undefined ? false : t5;
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - percentage * circumference;
  const activeStroke = strokeColor ?? colorHex ?? nebulyPalette[color];
  let t6;
  if ($[0] !== className) {
    t6 = cn("relative z-0 flex items-center gap-0.5 text-white", className);
    $[0] = className;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const t7 = radius * 2;
  const t8 = radius * 2;
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      transform: "rotate(-90deg)"
    };
    $[2] = t9;
  } else {
    t9 = $[2];
  }
  let t10;
  if ($[3] !== normalizedRadius || $[4] !== radius || $[5] !== stroke) {
    t10 = <circle stroke="#333" fill="transparent" strokeWidth={stroke} r={normalizedRadius} cx={radius} cy={radius} />;
    $[3] = normalizedRadius;
    $[4] = radius;
    $[5] = stroke;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  const t11 = circumference + " " + circumference;
  let t12;
  if ($[7] !== strokeDashoffset) {
    t12 = {
      strokeDashoffset
    };
    $[7] = strokeDashoffset;
    $[8] = t12;
  } else {
    t12 = $[8];
  }
  let t13;
  if ($[9] !== activeStroke || $[10] !== normalizedRadius || $[11] !== radius || $[12] !== stroke || $[13] !== t11 || $[14] !== t12) {
    t13 = <circle stroke={activeStroke} fill="transparent" strokeWidth={stroke} strokeDasharray={t11} style={t12} r={normalizedRadius} cx={radius} cy={radius} />;
    $[9] = activeStroke;
    $[10] = normalizedRadius;
    $[11] = radius;
    $[12] = stroke;
    $[13] = t11;
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t10 || $[17] !== t13 || $[18] !== t7 || $[19] !== t8) {
    t14 = <svg height={t7} width={t8} style={t9}>{t10}{t13}</svg>;
    $[16] = t10;
    $[17] = t13;
    $[18] = t7;
    $[19] = t8;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== displayAsNumber || $[22] !== hideLabel || $[23] !== number || $[24] !== percentage) {
    t15 = hideLabel ? null : <span>{displayAsNumber ? number : (percentage * 100).toFixed(0) + "%"}</span>;
    $[21] = displayAsNumber;
    $[22] = hideLabel;
    $[23] = number;
    $[24] = percentage;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t14 || $[27] !== t15 || $[28] !== t6) {
    t16 = <div className={t6}>{t14}{t15}</div>;
    $[26] = t14;
    $[27] = t15;
    $[28] = t6;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  return t16;
};
export default CircularPercentage;